import { Button, Col, Dropdown, Text } from 'components';
import { sports } from 'lib';
import { useTranslation } from 'react-i18next';

const levelList = ['Interested', 'Beginner', 'Amateur', 'Intermediate', 'Expert', 'Retired'];

const Item = ({ type, sport, setSport, position, setPosition, level, setLevel, index }) => {
  const sportsObject = sports.find((x) => x.name === sport),
    { t } = useTranslation();

  return (
    <Col marg={index && '18px 0 0'} wid="100%">
      <Dropdown
        title="Sport"
        admin
        options={sports}
        translatePrefix="sports"
        selected={sport}
        rounded
        handleSelect={setSport}
        placeholder="Select..."
        wid="100%"
        bg="#fff"
      />

      {sportsObject?.positions?.length && (
        <Dropdown
          title="Position"
          marg="8px 0 0"
          admin
          rounded
          wid="100%"
          options={sportsObject.positions}
          translatePrefix={sportsObject.name}
          placeholder="Select..."
          selected={position}
          bg="#fff"
          handleSelect={setPosition}
        />
      )}

      {type === 'fan' && !!sportsObject && (
        <Dropdown
          title="Level"
          marg="8px 0 0"
          admin
          rounded
          options={levelList}
          placeholder="Select..."
          selected={level}
          wid="100%"
          bg="#fff"
          handleSelect={setLevel}
        />
      )}
    </Col>
  );
};

const MySports = ({ type, data, setData }) => {
  function handleSportSelect(e, idx) {
    setData(
      data.map((x, i) => {
        if (i !== idx) return x;

        return {
          sport: e.name,
          position: ''
        };
      })
    );
  }

  function handlePositionChange(e, idx) {
    setData(
      data.map((x, i) => {
        if (i !== idx) return x;

        return { ...x, position: e };
      })
    );
  }

  function handleLevelChange(e, idx) {
    setData(
      data.map((x, i) => {
        if (i !== idx) return x;

        return { ...x, level: e };
      })
    );
  }

  function addRow() {
    setData([...data, { sport: '', position: '' }]);
  }

  return (
    <Col marg="40px 0 0" noFlex wid="100%">
      <Text marg="0" h4 bold>
        Sports
      </Text>

      <Col noFlex wid="100%" marg="24px 0 0">
        {data.map((x, i) => (
          <Item
            key={i}
            index={i}
            sport={x.sport}
            setSport={(e) => handleSportSelect(e, i)}
            position={x.position}
            setPosition={(e) => handlePositionChange(e, i)}
            level={x.level}
            setLevel={(e) => handleLevelChange(e, i)}
            type={type}
          />
        ))}
      </Col>

      {!!data[data.length - 1]?.sport && type !== 'athlete' && (
        <Button text="Add sport" onClick={addRow} marg="24px 0 0" icon="add" wid="100%" bordered />
      )}
    </Col>
  );
};

export default MySports;
